'use strict';

intellidealerAppShoppingCartModule.controller('ShoppingCartCheckoutCompleteController', function ($scope, $rootScope, $state, $stateParams, publicModeService, worldpayUrlService) {

  $scope.orderSummary = {
    company: $stateParams.company,
    division: $stateParams.division,
    location: $stateParams.location,
    referenceNumber: $stateParams.referenceNumber,
    salesOrderNumber: $stateParams.salesOrderNumber,
    customerNumber: $stateParams.customerNumber
  };

  $scope.viewOrderDetails = function() {
    var parameters = {
      company: $scope.orderSummary.company,
      division: $scope.orderSummary.division,
      location: $scope.orderSummary.location,
      referenceNumber: $scope.orderSummary.referenceNumber,
      salesOrderNumber: $stateParams.salesOrderNumber
    };
    $state.go('navigation.parts.previousOrders.previousOrdersDetails', parameters);
  };

  $scope.done = function () {
    if (!$rootScope.isPublicState) {
      $state.go('navigation.dashboard');
    } else {
      $state.go(publicModeService.getStateWithPrefix(true, '.parts.shopForParts'), {
        library: $stateParams.library || $state.params.library,
        company: $stateParams.company || $state.params.company,
        division: $stateParams.division || $state.params.division
      }).then(function () {
        worldpayUrlService.clearReturnSearchParams();
      });
    }
  };

});
